/** Cross-screen refresh after parent-account fee payment or account update. */
export const FEE_DATA_CHANGED = 'feeDataChanged';

export function dispatchFeeDataChanged(detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(FEE_DATA_CHANGED, { detail }));
}

export function subscribeFeeDataChanged(handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(FEE_DATA_CHANGED, handler);
  return () => window.removeEventListener(FEE_DATA_CHANGED, handler);
}
